import type { InventoryResource } from '@repo/api-gw-sdk';

import { ConfirmationDialog } from '@/components/dialogs/confirmationDialog';
import { useDAL } from '@/contexts/useDAL';

interface ExcludeFromBackupProps {
  isOpen: boolean;
  entities: InventoryResource[];
  onClose: () => void;
  onRefreshResources?: () => Promise<void>;
}

export function ExcludeFromBackupDialog(props: ExcludeFromBackupProps) {
  const { entities, isOpen, onClose, onRefreshResources } = props;
  const dal = useDAL();
  const { mutate: mutateLimits } = dal.inventory.limits.useLimit();

  const excludeFromBackup = async () => {
    await Promise.all(
      entities.map((entity) =>
        dal.inventory.resources.excludeResourceFromBackup(entity.id)
      )
    );
    if (onRefreshResources) {
      void onRefreshResources();
    }
    void mutateLimits();
    onClose();
  };
  return (
    <ConfirmationDialog
      isOpen={isOpen}
      title='Exclude from backup'
      description="Eon doesn't back up or report violations for excluded resources."
      onCancel={onClose}
      onConfirm={excludeFromBackup}
      confirmSnackbarText='Resource excluded from backup.'
      buttonIconClass='material-symbols-hide-source-outline-rounded'
      buttonTitle='Exclude'
    />
  );
}
